module.exports = __webpack_public_path__ + "img/help-time-span.91a96e78.webp";